var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"fill":"none","stroke":"currentColor","aria-hidden":"true","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"stroke-width":"3","stroke-linecap":"round","d":"M12 1.523v20.953M18.548 15.928L12 22.476M5.452 15.928L12 22.476"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }